import axios from "axios";

// const httpurl = 'https://hr-api-test.xyjhr.cn'; //测试
// const httpurl = 'http://localhost:24107'; //亚楠本地
// const httpurl = 'https://shop-test-api.xyjhr.cn'; //测试
const httpurl = 'https://shop-api.xyjhr.cn'; //线上
// const httpurl = 'http://8.130.208.169:38086'; //线上ip

// const httpurl = 'http://8.130.141.215:24107'; //正式IP
// const httpurl = 'http://localhost:38086'; // 雅楠
// const httpurl = 'http://192.168.31.29.:38086'; // 雅楠

export default {
    httpurl,
}



// WEBPACK FOOTER //
// ./src/assets/js/url.js